import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

// Firebase Configuration using environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize specific Firebase services
const auth = getAuth(app);

// Initialize Firestore with special configuration to solve "WebChannel transport errored"
const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  // If the above doesn't work, try this option:
  // experimentalForceLongPolling: true,
  merge: true,
});

const storage = getStorage(app);
const messaging = getMessaging(app);
const analytics = getAnalytics(app);

// Export services for use in other files
export { auth, db, storage, messaging, analytics, app as default };
